"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _HotelMenuBar = _interopRequireDefault(require("./HotelMenuBar"));
var _default = exports["default"] = _HotelMenuBar["default"];